import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IAuthUserImport, defaultValue } from 'app/shared/model/auth-user-import.model';

export const ACTION_TYPES = {
  FETCH_AUTHUSERIMPORT_LIST: 'authUserImport/FETCH_AUTHUSERIMPORT_LIST',
  FETCH_AUTHUSERIMPORT: 'authUserImport/FETCH_AUTHUSERIMPORT',
  CREATE_AUTHUSERIMPORT: 'authUserImport/CREATE_AUTHUSERIMPORT',
  UPDATE_AUTHUSERIMPORT: 'authUserImport/UPDATE_AUTHUSERIMPORT',
  DELETE_AUTHUSERIMPORT: 'authUserImport/DELETE_AUTHUSERIMPORT',
  RESET: 'authUserImport/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAuthUserImport>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type AuthUserImportState = Readonly<typeof initialState>;

// Reducer

export default (state: AuthUserImportState = initialState, action): AuthUserImportState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_AUTHUSERIMPORT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_AUTHUSERIMPORT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_AUTHUSERIMPORT):
    case REQUEST(ACTION_TYPES.UPDATE_AUTHUSERIMPORT):
    case REQUEST(ACTION_TYPES.DELETE_AUTHUSERIMPORT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_AUTHUSERIMPORT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_AUTHUSERIMPORT):
    case FAILURE(ACTION_TYPES.CREATE_AUTHUSERIMPORT):
    case FAILURE(ACTION_TYPES.UPDATE_AUTHUSERIMPORT):
    case FAILURE(ACTION_TYPES.DELETE_AUTHUSERIMPORT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHUSERIMPORT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHUSERIMPORT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_AUTHUSERIMPORT):
    case SUCCESS(ACTION_TYPES.UPDATE_AUTHUSERIMPORT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_AUTHUSERIMPORT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/auth-user-imports';

// Actions

export const getEntities: ICrudGetAllAction<IAuthUserImport> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_AUTHUSERIMPORT_LIST,
  payload: axios.get<IAuthUserImport>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IAuthUserImport> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_AUTHUSERIMPORT,
    payload: axios.get<IAuthUserImport>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IAuthUserImport> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_AUTHUSERIMPORT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAuthUserImport> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUTHUSERIMPORT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAuthUserImport> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AUTHUSERIMPORT,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
